import { render, staticRenderFns } from "./ModalInserirColaboracao.vue?vue&type=template&id=610fb684&scoped=true"
import script from "./ModalInserirColaboracao.vue?vue&type=script&lang=js"
export * from "./ModalInserirColaboracao.vue?vue&type=script&lang=js"
import style0 from "./ModalInserirColaboracao.vue?vue&type=style&index=0&id=610fb684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610fb684",
  null
  
)

export default component.exports